export const generateOptionsWith30MinIntervals = (): Array<{
  label: string;
  value: string;
}> => {
  return Array.from({ length: 48 }).map((_, index) => {
    const hours = Math.floor(index / 2);
    const minutes = index % 2 === 0 ? 0 : 30;
    const period = hours < 12 ? 'AM' : 'PM';

    const formattedHours = hours % 12 === 0 ? 12 : hours % 12;

    const option = `${formattedHours}:${minutes
      .toString()
      .padStart(2, '0')} ${period}`;

    return {
      label: option,
      value: option,
    };
  });
};
